var subscribeActions = function(){
  var header,
    headerImg,
    headerText,
    giftItems;

  var _init = function(){
    if (!_tabletPlus()) {return;}
    
    header = document.querySelector('.m-subscribe-header');
    headerImg = header.querySelector('.m-subscribe-header__image');
    headerText = header.querySelector('.m-subscribe-header__content');
    giftItems = document.querySelector('.m-subscribe-gifts');
    
    _animateHeader();
    _animateGifts();
  };

  var _animateHeader = function(){
    headerImg.classList.add('is-loaded');
    headerText.classList.add('is-loaded');
  };

  var _animateGifts = function(){
    if(_isInView(giftItems)){
      giftItems.classList.add('is-visible');
    }else{
      window.addEventListener('scroll', _onScroll);
    }
  };

  var _onScroll = function(){
    if (_isInView(giftItems)) {
      giftItems.classList.add('is-visible');
      window.removeEventListener('scroll', _onScroll);
    }
  };

  var _isInView = function(el){
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight + el.clientHeight|| document.documentElement.clientHeight + el.clientHeight)
    );
  };

  var _tabletPlus = function(){
    if (window.innerWidth > 767) {
      return true
    } else {
      return false;
    }
  };

  return{
    init: _init
  }
}();

if (document.body.classList.contains('page-template-tpl-subscribe')) {
  document.addEventListener('DOMContentLoaded', subscribeActions.init);
}